// Local Deps
import { makeGraphQLRequest } from '../../utils/requestUtils';

export default async function addToInventory({
  cage,
  partNum,
  niin,
  modifiedBy,
  price,
  ui,
  qup,
  soh,
  visibility,
  description,
}) {
  // Format Mutation
  const query = `mutation addInventory(
    $inventoryInput: NewInventoryInput
  ) {
    addInventory(inventory:$inventoryInput)
      {
        status
        msg
      }
    }`;

  // Variables
  const variables = {
    inventoryInput: {
      cage,
      partNum,
      niin,
      modifiedBy,
      price,
      ui,
      qup,
      soh,
      visibility,
      description,
    },
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// export async function getCageCode(id) {
//   const query = `query requestOrganizationById(
//     $id: ID
//   ) {
//       organization(id: $id) {
//         cageCode
//       }
//     }`;

//   const variables = { id };
//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });

//   return response;
// }

// export async function getOrgByID(id) {
//   // Format Query
//   const query = `query organization(
//     $id: ID
//   ) {
//     organization(id: $id) {
//       name
   
//       cageCode
     
//       }
//     }`;

//   // Variables
//   const variables = { id };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });
//   return response.organization;
// }



// WEBPACK FOOTER //
// ./src/components/AddInventory/graphql.js